import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

import { SysConfig } from './system-configuration.service';
import { CookieService } from './cookie';
import { CacheService } from './cache.service';

@Injectable()
export class RoutesService {
  static COOKIE_LANG_KEY: string = 'CURRENT_LANG';

  protected locales: string[];
  protected browserLangs: string[];
  protected visiblePageLoader: boolean = false;

  constructor(protected router: Router,
    protected translate: TranslateService,
    protected cookie: CookieService,
    protected location: Location,
    protected isBrowser: boolean,
    protected cache: CacheService) {
  }

  public loadRoutes() {
  }

  protected getRoutesWithComponents(rawRoutes) {
    return rawRoutes.map((route) => {
      if (route.component && 'string' === typeof route.component) {
        return Object.assign({}, route, {
          component: SysConfig.getComponentByName(route.component)
        });
      }
      return route;
    });
  }

  protected getOnlyOfflineRoutes(rawRoutes) {

    //Keeping only the offline route
    let offlineRawRoutes = []

    for (let rowRoute of rawRoutes) {
      if (rowRoute.name == "OFFLINE") {
        let redirectToRoute = {
          path: "",
          redirectTo: rowRoute.path,
          pathMatch: "full"
        }

        offlineRawRoutes.push(redirectToRoute);

        let offlineRoute = {
          path: rowRoute.path,
          component: rowRoute.component,
          name: rowRoute.name
        }

        offlineRawRoutes.push(offlineRoute);

        let fallBackRoute = {
          path: "**",
          redirectTo: rowRoute.path
        }

        offlineRawRoutes.push(fallBackRoute);

        break;
      }
      else {
        continue;
      }
    }

    return offlineRawRoutes;
  }

  public getLang(): string {
    if (!this.locales) {
      this.locales = this.cache.get('Locales');
    }
    let langFromUrl: string = null;
    let langFromUrlMatch: RegExpMatchArray;
    if (langFromUrlMatch = this.location.path().match(/^\/(\w{2})\//)) {
      langFromUrl = langFromUrlMatch[1];
    }
    let cookieLang: string = this.cookie.get(RoutesService.COOKIE_LANG_KEY);
    if (langFromUrl && this.locales.find((existLang) => existLang === langFromUrl)) {
      return langFromUrl;
    }
    if (cookieLang && this.locales.find((existLang) => existLang === cookieLang)) {
      return cookieLang;
    }
    for (let existBrowserLang of this.browserLangs) {
      if (this.locales.find((existLang) => existLang === existBrowserLang)) {
        return existBrowserLang;
      }
    }
    return this.locales[0];
  }

  public getRoutes(): any {

  }

  public getRoutePath(routeName: string): any {
    let routes = this.getRoutes();
    let routePath: string = "";



    if (routes != undefined && routes != null) {

      routes.filter(x => x.name == routeName).forEach(route => {
        routePath = "/" + route.path;
      });
    }
    //console.log(routes);
    //console.log(routes.filter(x => x.name == routeName));
    // for (let route of routes) {
    //     //if the name of the route match the one give in input then the relative route path is returned
    //     if (route.name == routeName) {
    //         routePath = "/" + route.path;
    //         break;
    //     }
    // }

    if (routePath === "") {
      routePath = "/";
    }
    return [routePath];
  }

  public getPage(routeName: string): any {
    let routePath: string = "/";
    if (routeName != "" || routeName != undefined) {
      let routes = this.getRoutes();
      if (routes != undefined) {
        if (routes != undefined && routes != null) {

          routes.filter(x => x.name == routeName).forEach(route => {
            routePath = "/" + route.path;
          });
        }
      }
    }
    return routePath;
  }

  showPageLoader() {
    this.visiblePageLoader = true;
  }

  hidePageLoader() {
    this.visiblePageLoader = false
    // window.setTimeout(() =>
    // this.visiblePageLoader = false, 1)
  }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/core/routes.service.ts